<template>
  <div class="hidden pt-24 font-semibold tracking-widest lg:block">
    <div class="flex">
      <a href="https://github.com/DominoxB" target="_blank">
        <div class="flex items-center gap-4">
          <img src="@/icons/github.png" alt="github" class="w-8 h-8" />
          <span class="">{{ $t('github') }}</span>
        </div>
      </a>
    </div>
    <div class="flex pt-6">
      <a href="https://www.linkedin.com/in/dominika-biedulska" target="_blank">
        <div class="flex items-center gap-4">
          <img src="@/icons/linkedin.png" alt="github" class="w-8 h-8" />
          <span class="">{{ $t('name') }}</span>
        </div>
      </a>
    </div>
  </div>
</template>
